export class NotificationPolicyConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "slack",
            "baseName": "slack",
            "type": "NotificationPolicyConfigSlack",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "NotificationPolicyConfigEmail",
            "format": ""
        },
        {
            "name": "sns",
            "baseName": "sns",
            "type": "NotificationPolicyConfigSns",
            "format": ""
        },
        {
            "name": "splunk",
            "baseName": "splunk",
            "type": "NotificationPolicyConfigSplunk",
            "format": ""
        },
        {
            "name": "webhook",
            "baseName": "webhook",
            "type": "NotificationPolicyConfigWebhook",
            "format": ""
        },
        {
            "name": "serviceNow",
            "baseName": "serviceNow",
            "type": "NotificationPolicyConfigServiceNow",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
